import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface UserSession {
  sessionId: number;
  employeeId: string;
  employeeName: string;
  clientSessionId: string;
  platform: string;
  lastSeen: string;
  revoked: boolean;
}

@Injectable({ providedIn: 'root' })
export class SessionService {

  private readonly baseUrl = `${environment.apiServiceBaseUrl}/hawdco/sessions`;

  constructor(private http: HttpClient) {}

  heartbeat(employeeId: string, employeeName: string | null, clientSessionId: string, platform = 'web'): Observable<{ kicked: boolean }> {
    return this.http.post<{ kicked: boolean }>(`${this.baseUrl}/heartbeat`, {
      employeeId, employeeName, clientSessionId, platform
    });
  }

  getActive(): Observable<UserSession[]> {
    return this.http.get<UserSession[]>(`${this.baseUrl}/active`);
  }

  /** End one specific session (one row) by its id. */
  revoke(sessionId: number): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${sessionId}/revoke`, {});
  }

  /** End every session belonging to one employee (web + mobile). */
  revokeByEmployee(employeeId: string): Observable<{ revoked: number }> {
    return this.http.post<{ revoked: number }>(`${this.baseUrl}/employee/${employeeId}/revoke`, {});
  }

  revokeAll(): Observable<{ revoked: number }> {
    return this.http.post<{ revoked: number }>(`${this.baseUrl}/revoke-all`, {});
  }
}
